import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WarningScreenComponent } from '@approot/modals/warning-screen/warning-screen.component';
import { SelectorComponent } from '@approot/selector/selector.component';
import { UIKitModule } from '@approot/ui-kit/ui-kit.module';
import { ClarityModule, ClrIconModule } from '@clr/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReusableGridTemplateComponent } from '../shared/custom-components/ag-grid/reusable-grid-template/reusable-grid-template.component';
import { TextBoxEditorComponent } from './custom-components/ag-grid/text-box-editor/text-box-editor.component';
import { BanksSelectorComponent } from './custom-components/banks-selector/banks-selector.component';
import { BanksSelectorDirective } from './custom-components/banks-selector/banks-selector.directive';
import { ClarityDatagridFilterComponent } from './custom-components/clarity-datagrid-filter/clarity-datagrid-filter.component';
import { DateWithSpinnerInfoComponent } from './custom-components/date-with-spinner-info/date-with-spinner-info.component';
import { InputWithSpinnerComponent } from './custom-components/input-with-spinner/input-with-spinner.component';
import { LoadingSpinnerComponent } from './custom-components/loading-spinner/loading-spinner.component';
import { NumberHighlighterComponent } from './custom-components/number-highlighter/number-highlighter.component';
import { IndicativePremiumPipe } from './custom-components/rfq-quotes/indicative-premium.pipe';
import { SelectorMultiComponent } from './custom-components/selector-multi/selector-multi.component';
import { TwoWaySpotComponent } from './custom-components/two-way-spot/two-way-spot.component';
import { ResizerHorizontalDirective } from './directives/resizer-horizontal/resizer-horizontal.directive';
import { ResizerVerticalDirective } from './directives/resizer-vertical/resizer-vertical.directive';
import { InputValidatorDirective } from './directives/validators/input-validator.directive';
import {
  AbsPipe,
  ArrayOfObjectsToSingleItemArrayPipe,
  IncludedInPipe,
  LengthOfArrayPipe,
  PrettyDatePipe,
  SecondsToMinutesPipe,
  ShortNameToLongNamePipe,
  StrikeFormatterPipe,
  ValueColorsHeatMapPipe,
  ValueColorsHeatMapSignedPipe
} from './pipes';
import { ArrayAttributeMapPipe } from './pipes/array-attribute-map/array-attribute-map.pipe';
import { CleanFormattedNumericPipe } from './pipes/cleanFormattedNumeric/clean-formatted-numeric.pipe';
import { CountDownColorClassPipe } from './pipes/count-down-color/count-down-color-class.pipe';
import { ForwardPointsFormatterPipe } from './pipes/forward-points-formatter/forward-points-formatter.pipe';
import { SortHedgeQuotesPipe } from './pipes/sort-hedge-quotes.pipe';
import { SplitPipe } from './pipes/split/split.pipe';
import { ZeroNumberFormatterPipe } from './pipes/zero-number-formatter.pipe';

@NgModule({
  declarations: [
    AbsPipe,
    ArrayAttributeMapPipe,
    ArrayOfObjectsToSingleItemArrayPipe,
    BanksSelectorComponent,
    BanksSelectorDirective,
    ClarityDatagridFilterComponent,
    CleanFormattedNumericPipe,
    CountDownColorClassPipe,
    DateWithSpinnerInfoComponent,
    IncludedInPipe,
    IndicativePremiumPipe,
    InputValidatorDirective,
    InputWithSpinnerComponent,
    LengthOfArrayPipe,
    LoadingSpinnerComponent,
    NumberHighlighterComponent,
    PrettyDatePipe,
    ResizerHorizontalDirective,
    ResizerVerticalDirective,
    ReusableGridTemplateComponent,
    SecondsToMinutesPipe,
    SelectorMultiComponent,
    ShortNameToLongNamePipe,
    SortHedgeQuotesPipe,
    SplitPipe,
    StrikeFormatterPipe,
    TextBoxEditorComponent,
    TwoWaySpotComponent,
    ValueColorsHeatMapPipe,
    ValueColorsHeatMapSignedPipe,
    WarningScreenComponent,
    ZeroNumberFormatterPipe,
    ForwardPointsFormatterPipe
  ],
  imports: [
    ClarityModule,
    ClrIconModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    NgSelectModule,
    ReactiveFormsModule,
    SelectorComponent,
    UIKitModule
  ],
  exports: [
    AbsPipe,
    ArrayAttributeMapPipe,
    ArrayOfObjectsToSingleItemArrayPipe,
    BanksSelectorComponent,
    BanksSelectorDirective,
    ClarityDatagridFilterComponent,
    ClarityModule,
    CleanFormattedNumericPipe,
    ClrIconModule,
    CommonModule,
    CountDownColorClassPipe,
    DateWithSpinnerInfoComponent,
    DragDropModule,
    FormsModule,
    IncludedInPipe,
    IndicativePremiumPipe,
    InputValidatorDirective,
    InputWithSpinnerComponent,
    LengthOfArrayPipe,
    LoadingSpinnerComponent,
    NgSelectModule,
    NumberHighlighterComponent,
    PrettyDatePipe,
    ReactiveFormsModule,
    ResizerHorizontalDirective,
    ResizerVerticalDirective,
    SecondsToMinutesPipe,
    SelectorComponent,
    SelectorMultiComponent,
    ShortNameToLongNamePipe,
    SortHedgeQuotesPipe,
    SplitPipe,
    StrikeFormatterPipe,
    TwoWaySpotComponent,
    UIKitModule,
    ValueColorsHeatMapPipe,
    ValueColorsHeatMapSignedPipe,
    WarningScreenComponent,
    ZeroNumberFormatterPipe,
    ForwardPointsFormatterPipe
  ],
  providers: [ShortNameToLongNamePipe]
})
export class SharedModule {}
